/**
 * @file LlUriInput组件引出
 */

import { withInstall } from '@ll-plus/utils'

import UriInput from './src/uri-input.vue'

export const LlUriInput = withInstall(UriInput)
export default LlUriInput
export * from './src/uri-input'

declare module 'vue' {
  export interface GlobalComponents {
    LlUriInput: typeof LlUriInput
  }
}
